import { AfterViewInit, Component, ElementRef, Inject, Injector, NgZone, OnDestroy, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { WebcomponentsService } from '@core/service/webcomponents.service';
import { HeaderService } from '../../header.service';
import { VIRTUAL_CARD_STATUS_ENUMERATION } from '@home/header/configs';

export interface OtpDialogDataType {
  clientId: string;
  otpType: string;
  cardId: string;
}

@Component({
  selector: 'app-otp-dialog',
  templateUrl: './otp-dialog.component.html',
  styleUrls: ['./otp-dialog.component.scss'],
})
export class OtpDialogComponent implements AfterViewInit, OnDestroy {
  @ViewChild('otpRef', { static: false }) public otpWebComponent: ElementRef;

  private readonly ngZone: NgZone;
  private readonly dialogRef: MatDialogRef<OtpDialogComponent>;
  private readonly webComponentService: WebcomponentsService;
  private readonly headerService: HeaderService;
  private readonly unSubscribe$: Subject<void>;
  @Inject(MAT_DIALOG_DATA) private readonly data: OtpDialogDataType;

  public isLoading: boolean;

  constructor(private readonly injector: Injector) {
    this.ngZone = this.injector.get(NgZone);
    this.dialogRef = this.injector.get(MatDialogRef);
    this.webComponentService = this.injector.get(WebcomponentsService);
    this.headerService = this.injector.get(HeaderService);
    this.data = this.injector.get(MAT_DIALOG_DATA);

    this.isLoading = false;
    this.unSubscribe$ = new Subject();
  }

  public ngAfterViewInit(): void {
    this.initOtpWebComponent();
  }

  public ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  private initOtpWebComponent(): void {
    const otp = this.otpWebComponent.nativeElement;

    this.webComponentService.isLoaded$.pipe(takeUntil(this.unSubscribe$)).subscribe({
      next: (loaded) => {
        if (loaded) {
          otp.ngElementStrategy.componentRef.instance.build({
            clientId: this.data.clientId,
            otpType: this.data.otpType,
            continueActionFn: this.continueActionFn.bind(this),
            cancelActionFn: this.close.bind(this),
          });
        }
      },
    });
  }

  public close(): void {
    this.ngZone.run(() => {
      this.dialogRef.close({ success: false });
    });
  }

  public continueActionFn(): void {
    this.ngZone.run(() => {
      this.isLoading = true;
      this.headerService
        .updateCardStatus(this.data.cardId, VIRTUAL_CARD_STATUS_ENUMERATION.ACTIVE)
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe({
          next: () => {
            this.isLoading = false;
            this.dialogRef.close({ success: true });
          },
          error: () => {
            this.isLoading = false;
          },
        });
    });
  }
}
